import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Dialog, DialogActions, DialogContent } from '@guildeducationinc/recess';
import InfoOutlinedIcon from '@guildeducationinc/recess/icons/InfoOutlinedIcon';
import { ProgramContext } from '@src/contexts/ProgramContextProvider';
import { EntityType, OtherOption } from '@src/types';
import { getSchoolPolicy } from '@src/utilities/benefitsHelper';
import { sanitizePaymentRequestForSpec } from '@src/utilities/paymentRequestHelper';
import { DataTable, TrackableButton, useLocale, useLookupOptions } from 'pe-core-frontend';
import { useContext, useState } from 'react';
export const AllowedFieldsOfStudyModal = () => {
    const { t } = useLocale();
    const { benefitProgramProps, paymentRequest, program, myBenefits } = useContext(ProgramContext);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [fosOptions, setFosOptions] = useState([]);
    const schoolPolicy = getSchoolPolicy(myBenefits, program);
    const { fetchOptions } = useLookupOptions({
        extraData: {
            program: benefitProgramProps,
            paymentRequest: paymentRequest
                ? sanitizePaymentRequestForSpec(paymentRequest)
                : undefined,
        },
    });
    const handleClick = async () => {
        if (loading)
            return;
        setShowModal(true);
        setLoading(true);
        try {
            const result = await fetchOptions({
                clientId: program.clientId,
                entityType: EntityType.PROGRAM,
                fieldCode: 'field_of_study_id',
                query: '',
                fetchAll: true,
            });
            let options = result.options || [];
            // Filter out "Other" (id=-1) when policy disallows it
            if (schoolPolicy?.otherFieldOfStudy === OtherOption.DISALLOW) {
                options = options.filter(opt => opt.value !== '-1');
            }
            setFosOptions(options);
        }
        catch (error) {
            console.error('Failed to fetch allowed fields of study:', error);
            setFosOptions([]);
        }
        finally {
            setLoading(false);
        }
    };
    const rows = fosOptions.map((opt, index) => ({
        id: opt.value || index,
        name: opt.label,
    }));
    return (_jsxs(_Fragment, { children: [_jsx(TrackableButton, { btnType: 'icon', enText: 'View allowed fields of study', tag: 'allowed_fos_lookup', label: t('View allowed fields of study'), onClick: handleClick, appearance: 'minimal', icon: _jsx(InfoOutlinedIcon, { size: 16 }) }), _jsxs(Dialog, { isOpen: showModal, title: t('Allowed Fields of Study'), onClose: () => setShowModal(false), children: [_jsx(DialogContent, { children: _jsx("div", { className: 'mt-2 weglot-exclude', children: _jsx(DataTable, { disableRowSelectionOnClick: true, disableColumnMenu: true, rows: rows, loading: loading, autoHeight: true, hideFooter: rows.length <= 10, pageSizeOptions: [10, 25], initialState: {
                                    pagination: { paginationModel: { pageSize: 10 } },
                                }, columns: [
                                    {
                                        field: 'name',
                                        headerName: t('Name'),
                                        flex: 1,
                                    },
                                ] }) }) }), _jsx(DialogActions, { fullScreen: false, children: _jsx(TrackableButton, { enText: 'Close', tag: 'allowed_fos_modal', appearance: 'outline', onClick: () => setShowModal(false), children: t('Close') }) })] })] }));
};
